import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { LoginService } from '../../../../services/authentication/login.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-kpidriver',
  templateUrl: './kpidriver.component.html',
  styleUrls: ['./kpidriver.component.css']
})
export class KpidriverComponent extends BaseCrudComponent {
  	@ViewChild('myCanvas', {static: false}) myCanvas: ElementRef;

  	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    
    totals:any;
    frozenCols:any;
    loadingRequired = false;

    //filters data
    dropdowns:any;
    sr_filter:any;
    hr_filter:any;
    driver_filter:any;
    ds_filter:any;
    rs_filter:any;

    sel_delivery:any;
    avg_score:any;

    // Radar
  	public radarChartLabels: string[] = [];
  	
  	public radarChartData: any = [
  		{data:[], label:''}
  	];

    public branches:any;
    public SubsidiaryId:any;
    public usr_subsidiary:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService,
        private login: LoginService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'LogisticKpis/EffectivenessDriver';
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.dropdowns = [];
        this.radarChartData = null;

        this.frozenCols = [
            //{ field: 'guideNumber', header: 'Guia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'}
        ];

        this.theaders = [
        	{ field: 'driver', header: 'Conductor', sortable:true, sortfield:'driver', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:'', filter:'input', chart:false},
            { field: 'groupDriver', header: 'Grupo', sortable:true, sortfield:'groupDriver', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'totalDelivered', header: 'Total entregas realizadas', sortable:true, sortfield:'totalDelivered', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:true},
            { field: 'totalNotDelivered', header: 'Total pedidos no entregados', sortable:true, sortfield:'totalNotDelivered', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:true},
            { field: 'totalRoute', header: 'Total rutas realizadas', sortable:true, sortfield:'totalRoute', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:true},
            { field: 'totalRouteNotOptimal', header: 'Total rutas óptimas no ejecutadas', sortable:true, sortfield:'totalRouteNotOptimal', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:true},
            { field: 'score', header: 'Delivery Score', sortable:true, sortfield:'scoreNumeric', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false}
        ];

        this.branches = [];
        this.SubsidiaryId = null;
        this.usr_subsidiary = -1;
    }

    ngOnInit() {
        this.clearFilters();

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();

            this.getBranchesData().subscribe(b => {
                this.loadingRequired = false;
                if( b != false ){
                    this.branches = b;
                }
            });

            this.login.getTeam().then(t => {
                if( (t == undefined) || (t == null) ){
                    t = 0;
                }
                
                this.usr_subsidiary = t;
            });
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.avg_score = 0;
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Start: this.f_datefrom,
            End: this.f_dateto,
            SubsidiaryId: (this.SubsidiaryId == 0) ? null : this.SubsidiaryId
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.rows = rs.details;

                this.radarChartLabels = [];
                this.radarChartData = [];

                //set chart labels
                this.theaders.forEach(h => {
                	if( h.chart ){
                		this.radarChartLabels.push(h.header);
                	}
                });

                //set chart data
                this.rows.forEach(r =>{
                	let tmp = {data:[], label:r['driver']};
                	this.theaders.forEach(j => {
                		if( j.chart ){
                			tmp.data.push(r[j.field]);
                		}
                	});

                	this.radarChartData.push(tmp);
                });

                this.avg_score = rs.scorePercent;
                //console.log(this.myCanvas.nativeElement.getContext('2d'));
                //console.log(this.myCanvas.nativeElement.getContext('2d').toDataURL());
                //console.log(document.getElementsByTagName("canvas"));
                //console.log(this.radarChartData);
            }
        });
    }

    public clearFilters(){
    	this.sr_filter = '';
	    this.hr_filter = '';
	    this.driver_filter = '';
	    this.ds_filter = '';
	    this.rs_filter = '';

	    let today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = today;
        this.f_dateto = today;
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'kpi_efec_conductor').subscribe(() => {
          // save started
        });
    }

    public getBranchesData(){
        var par_url = 'Subsidiary/All';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

}
